import axios from '@/libs/api.request'
import config from '@/config'

const baseCloudUrl = config.basePrivateCloudUrl
const privateCloudBaseUrl = baseCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudFlavor = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'flavor/',
    params: params,
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const getPrivateCloudAllFlavor = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_flavor_list/',
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudFlavor = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'flavor/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudFlavor = (data, id) => {
  let url = privateCloudBaseUrl + 'flavor/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudFlavor = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'flavor/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
